import React from "react";
import PayoutsTable from "../../components-bootstrap/PayoutsTable";
import PaginationModified from "../../../data/PaginationModified";

const ExpiringMemberships = ({
  total,
  tableColumns,
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  selectedTab,
  searchString,
  setSearchString,
  onClickSearch,
  totalMembers,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="allPtMembersTableContainer insideAccordianTableContainer">
      <div className="horizontallyScrollCardsContainer">
        <div className="cussss renewlaCustomDraggable">
          <div className="cardsCotaier">
            {selectedTab !== "all_renewals" && (
              <div className="cardBox" style={{ cursor: "not-allowed" }}>
                <div className="oneSideCard left">
                  <span className="tagName">total members </span>
                  <p className="totalTag">{totalMembers || 0}</p>
                </div>
                <div className="oneSideCard rigth"></div>
              </div>
            )}

            <div className="cardBox" style={{ cursor: "not-allowed" }}>
              <div className="oneSideCard left">
                <span className="tagName">
                  total amount{" "}
                  {selectedTab === "all_renewals" ? "(Renewals)" : ""}
                </span>
                <p className="totalTag">
                  {selectedTab === "all_renewals"
                    ? total || 0
                    : `₹${total || 0}`}
                </p>
              </div>
              <div className="oneSideCard rigth"></div>
            </div>
          </div>
        </div>

        <div
          className="tabsChild span2 width50Percent searchBarContainer"
          style={{ marginBottom: "20px" }}
        >
          <input
            type="search"
            className="input-k px-3"
            placeholder="Search by name ,number or email"
            value={searchString}
            onChange={(e) => setSearchString(e.target.value)}
          />
          <button
            type="button"
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
            onClick={onClickSearch}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-search"
              viewBox="0 0 16 16"
            >
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
            </svg>
          </button>
        </div>
      </div>

      <div className="fullWidthFlexCenter">
        <div className="customTableContainer">
          <PayoutsTable dataValues={tableData} columnsValues={tableColumns} />
        </div>

        <div className="customTablePaginationContainer">
          <PaginationModified
            isPage={isPage}
            onChangePage={setIsPage}
            pagination={getPagination()}
          />
        </div>
      </div>
    </div>
  );
};

export default ExpiringMemberships;
